import { useAccount } from '@azure/msal-react';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Unauthorized from '../../../pages/Unauthorized';
import { localAuth } from '../../api/auth';

export type PrivateRouteProps = {
    role?: string[];
};

const PrivateRoute = ({ role }: PrivateRouteProps) => {
    const account = useAccount();
    const nav = useNavigate();

    const isLocalAuth = localAuth.isAuth();

    let isAuth: boolean | null;

    if (!role) {
        isAuth = isLocalAuth;
    } else {
        isAuth =
            isLocalAuth &&
            (account?.idTokenClaims?.roles?.some((roleClaim) =>
                role.some((r) => r === roleClaim)
            ) ||
                false);
    }

    React.useEffect(() => {
        if (!isAuth) {
            nav('/login');
        }
    }, [isAuth, nav]);

    return isAuth ? <Outlet /> : <Unauthorized />;
};

export default PrivateRoute;
